import { useTranslation } from 'react-i18next';
import { workspaceType } from '@platform/navigation';
import { cx } from '@platform/core/lib/cx';
import { initials } from './initials';
import type { IWorkspaceMenuItemProps } from './IWorkspaceMenuItemProps';
import { useWorkspaceCounts } from './useWorkspaceCounts';

/**
 * Пункт меню робочих просторів (прототип v4): плитка 26px кольору типу простору з ініціалами, назва 600 з «…», «N учасників · M модулів»
 * (M — типи записів простору, як ws.modules прототипу; з каталогу платформи — useWorkspaceCounts), ✓ на поточному просторі.
 */
export function WorkspaceMenuItem({ workspace, active, onSelect }: IWorkspaceMenuItemProps) {
  const { t } = useTranslation();
  const counts = useWorkspaceCounts(workspace.id, workspace.type === 'parliament');
  const meta = [counts.members !== undefined && t('shell.members', { count: counts.members }), counts.modules !== undefined && t('shell.modulesCount', { count: counts.modules })].filter(Boolean).join(' · ');
  return (
    <button type="button" role="menuitemradio" aria-checked={active} className={cx('tb-wsmenu__item', active && 'is-active')} onClick={() => onSelect(workspace.id)}>
      <span className="tb-wsmenu__tile" style={{ background: workspaceType(workspace.type).tone }} aria-hidden="true">{initials(workspace.name)}</span>
      <span className="tb-wsmenu__text">
        <span className="tb-wsmenu__name">{workspace.name}</span>
        <span className="tb-wsmenu__meta">{meta || ' '}</span>
      </span>
      {active && <span className="tb-wsmenu__check" aria-hidden="true">✓</span>}
    </button>
  );
}
